import { render, staticRenderFns } from "./OrdensServicoForm.vue?vue&type=template&id=3eccc9a1&scoped=true&"
import script from "./OrdensServicoForm.vue?vue&type=script&lang=js&"
export * from "./OrdensServicoForm.vue?vue&type=script&lang=js&"
import style0 from "./OrdensServicoForm.vue?vue&type=style&index=0&id=3eccc9a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eccc9a1",
  null
  
)

export default component.exports